import { Enum, EnumType } from 'ts-jenum';
import { WellKnownIconsEnum } from 'src/app/helper/iconHelper';
import { IconDefinition } from '@fortawesome/pro-duotone-svg-icons';
import { AssistanceState } from 'src/generated/signalR/assistance-state';
import _ from 'lodash';

@Enum<AssistanceStateEnum>('name')
export class AssistanceStateEnum extends EnumType<AssistanceStateEnum>() {
   static readonly UNKNOWN = new AssistanceStateEnum('Unknown', AssistanceState.Unknown, null, null);
   static readonly NONE = new AssistanceStateEnum('None', AssistanceState.None, null, null);
   static readonly REQUIRE_ASSISTANCE = new AssistanceStateEnum('RequireAssistance', AssistanceState.RequireAssistance, null, null);
   static readonly BARGING_IN = new AssistanceStateEnum('BargingIn', AssistanceState.BargingIn, null, null);
   static readonly LISTENING = new AssistanceStateEnum(
      'Listening',
      AssistanceState.Listening,
      WellKnownIconsEnum.BARGE_IN_LISTEN.icon,
      'samwin.types.assistance_state.listening'
   );
   static readonly WHISPERING = new AssistanceStateEnum(
      'Whispering',
      AssistanceState.Whispering,
      WellKnownIconsEnum.BARGE_IN_WHISPER.icon,
      'samwin.types.assistance_state.whispering'
   );
   static readonly CONFERENCE = new AssistanceStateEnum(
      'Conference',
      AssistanceState.Conference,
      WellKnownIconsEnum.BARGE_IN_CONFERENCE.icon,
      'samwin.types.assistance_state.conferencing'
   );

   private constructor(public name: string, public enumValue: number, public icon: IconDefinition, public stateText: string) {
      super();
   }

   public static fromAssistanceStateValue(state: AssistanceState): AssistanceStateEnum {
      return _.find(AssistanceStateEnum.values(), (s) => s.enumValue === state) ?? AssistanceStateEnum.UNKNOWN;
   }
}
